import { css } from 'styled-components';
export const baseInputCss = css `
  background: transparent;
  color: var(--text-12);

  border: none;
  outline: none;
  height: 100%;
  width: 100%;

  &::placeholder {
    color: var(--textA-8);
    font-weight: 400;
    line-height: 20px;
  }
  &::selection {
    background-color: var(--backgroundA-7);
  }

  caret-color: var(--primary-9);

  &:disabled {
    color: var(--background-6);
  }
`;
//# sourceMappingURL=input-styles.js.map